import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ResultadoService } from './services/resultado.service';
import { IResultado, IResultadoResponse } from './interfaces/resultado.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-abc-resultados',
  templateUrl: './abc-resultados.component.html',
  providers: [MessageService]
})
export class AbcResultadosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedResultado: IResultado | null = null;
  dataSource: IResultado[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'sResultado', header: 'Clave', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'efectivo', header: 'Efectivo', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private resultadoService: ResultadoService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    
    this.resultadoService.getResultadosDefault().subscribe({
      next: (response: IResultadoResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los resultados'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los resultados'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedResultado = null;
    this.displayDialog = true;
  }

  openUpdate(row: IResultado): void {
    this.selectedResultado = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IResultado): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Desea eliminar el resultado ${row.sResultado}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.resultadoService.deleteResultado(row.sResultado).subscribe({
          next: (response) => {
            // Si success es true o si el error es "0", consideramos que fue exitoso
            if (response.success || (response.data?.[0]?.error === "0")) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Resultado eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.[0]?.error || 'Error al eliminar el resultado'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el resultado'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedResultado = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 